import { Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, Tooltip } from "@mui/material";
import { FieldAttributes, useField, useFormikContext } from "formik";
import { useEffect, useMemo, useState } from "react";
import InfoIcon from "@mui/icons-material/Info";
import { AppFlags } from "../../helper/config";

export const FMSelectRolesCustomcopy = ({ variant,UsersBL,Roles, isDiligent, ...props }:any) => {
    const selectedTypes: string[] = useMemo(() => {
        return UsersBL.roleIds ? UsersBL.roleIds.trim().split(',').map((item :string)=> item.trim()) : [];
        }, [UsersBL.roleIds]);

    const [field, meta] = useField<{}>(props);
    const { setFieldValue } = useFormikContext() ?? {};
    const errorText = meta.error && meta.touched ? meta.error : "";
    const [selectedOptions, setSelectedOption] = useState<string[]>([]);

    const roleDescriptions = useMemo(() => {
        const base: { [key: string]: string[] } = {
            "Client Admin": [
                "Filing Queue / Non-Premium Endorsements",
                "State Reports",
                "Inbox",
                "State Information Portal",
                "Diligent Search",
                "User Settings",
            ],
            "Client Accounting": [
                " Create/Edit/Delete users",
                " upload documents",
                " reply to messages sent from MISC"
            ],
            "Client Operations": [
                "Upload documents and reply to messages sent by MISC",
            ],
            "Client Processors": [
                "Filing Queue / Non-Premium Endorsements",
                "Inbox",
                "State Information Portal",
            ],
            "State Reporter": [
                "State Reports",
                "Inbox",
                "State Information Portal",
            ],
            "Diligent Search User": [
                "Diligent Search",
            ],
        };
        if (AppFlags.enableStateReports) {
            return base;
        }
        const omitStateReports = (lines: string[]) =>
            lines.filter((line) => line.trim() !== "State Reports");
        return Object.fromEntries(
            Object.entries(base).map(([k, v]) => [k, omitStateReports(v)])
        );
    }, []);

    useEffect(() => {
        setSelectedOption(selectedTypes)
    }, [selectedTypes])

    return (
        <FormControl error={!!errorText} fullWidth>
            <FormHelperText className="formtexthelper-heading"></FormHelperText>
            <FormGroup sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 1 }}>
                {Roles
                .filter((role: any) => isDiligent || role.roleName !== "Diligent Search User")
                .map((role: any) => {
                    const isDiligentRole = role.roleName === "Diligent Search User";
                    return (
                        <div key={role.roleId} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={
                                            isDiligentRole && isDiligent === false
                                                ? false
                                                : selectedOptions.includes(role.roleId.toString())
                                        }
                                        onChange={(e) => {
                                            let updatedOptions = e.target.checked
                                                ? [...selectedOptions, role.roleId.toString()]
                                                : selectedOptions.filter((id) => id !== role.roleId.toString());
                                            setSelectedOption(updatedOptions);
                                            setFieldValue("roleIds", updatedOptions.join(","));
                                        }}
                                        disabled={false}
                                    />
                                }
                                label={role.roleName}
                            />
                            <Tooltip
                                title={
                                    <div style={{
                                        maxWidth: "320px",
                                        padding: "12px",
                                        fontSize: "16px",
                                        textAlign: "left",
                                        whiteSpace: "pre-line"
                                    }}>
                                        <ul style={{ marginBottom: "0rem" }}>
                                            {roleDescriptions[role.roleName].map((sentence: string, index: number) => (
                                                <li key={index}>{sentence}</li>
                                            ))}
                                        </ul>
                                    </div>
                                }
                                arrow
                            >
                                <InfoIcon fontSize="small" style={{ cursor: "pointer", color: 'grey' }} />
                            </Tooltip>
                        </div>
                    );
                })}
            </FormGroup>
            <FormHelperText>{errorText}</FormHelperText>
        </FormControl>
    );
};